import { apiClient, type ApiResponse } from './client'

export type ConsultationChannel = 'PHONE' | 'IN_PERSON' | 'MESSAGE' | 'OTHER'
export type ConsultationCounterpart = 'GUARDIAN' | 'LEARNER' | 'OTHER'
export type ConsultationTopic = 'LEARNING' | 'ATTENDANCE' | 'ENROLLMENT' | 'OTHER'

export const CONSULTATION_CHANNELS: ConsultationChannel[] = ['PHONE', 'IN_PERSON', 'MESSAGE', 'OTHER']
export const CONSULTATION_COUNTERPARTS: ConsultationCounterpart[] = ['GUARDIAN', 'LEARNER', 'OTHER']
export const CONSULTATION_TOPICS: ConsultationTopic[] = ['LEARNING', 'ATTENDANCE', 'ENROLLMENT', 'OTHER']

/** 시각 필드는 +09:00 offset이 붙은 ISO 문자열이다. */
export interface LearnerConsultationView {
  consultationId: number
  learnerUserId: number
  consultedAt: string
  channel: ConsultationChannel
  counterpart: ConsultationCounterpart
  topic: ConsultationTopic
  content: string
  authorName: string | null
  createdAt: string
  updatedAt: string | null
  updatedByName: string | null
}

/** consultedAt은 offset 필수(예: 2026-10-22T14:30:00+09:00). */
export interface LearnerConsultationBody {
  consultedAt: string
  channel: ConsultationChannel
  counterpart: ConsultationCounterpart
  topic: ConsultationTopic
  content: string
}

export const learnerConsultationApi = {
  list: (userId: number) =>
    apiClient.get<ApiResponse<LearnerConsultationView[]>>(`/lc/admin/students/${userId}/consultations`),
  create: (userId: number, body: LearnerConsultationBody) =>
    apiClient.post<ApiResponse<LearnerConsultationView>>(`/lc/admin/students/${userId}/consultations`, body),
  update: (consultationId: number, body: LearnerConsultationBody) =>
    apiClient.put<ApiResponse<LearnerConsultationView>>(`/lc/admin/consultations/${consultationId}`, body),
  remove: (consultationId: number) =>
    apiClient.delete<ApiResponse<unknown>>(`/lc/admin/consultations/${consultationId}`),
}
